// extracted by mini-css-extract-plugin
export default {"auth":"layout_auth__yJuw3","main-content-view":"layout_main-content-view__x1lOW","authScroll":"layout_authScroll__Hjd8c"};